import React from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';

export const UpgradeModal = ({ visible, info, onClose, onConfirm, loading }) => {
  const { t } = useTranslation();

  if (!visible) return null;

  return createPortal(
    <div className='fixed z-[9999] h-[100vh] w-[100vw] bg-[#00000080] inset-0 flex justify-center items-center'>
      <div className='flex flex-col items-center justify-between w-[45vh] max-w-[482px] min-w-[382px] aspect-[1.6/1] bg-[#d8d8d8] rounded-2xl gap-2 px-6 py-6 text-[#2D2D2D]'>
        <span className='font-bold text-xl'>{t('SUBSCRIPTION_PLAN_CHANGE_TITLE')}</span>
        <span className='text-sm text-left text-[#666666]'>
          {t('SUBSCRIPTION_PLAN_CHANGE_DESC')}
          <span className='text-[#2D2D2D] font-bold'>{t('SUBSCRIPTION_PLAN_CHANGE_TIP')}</span>
        </span>
        <div className='flex flex-row w-full justify-between text-sm mt-2'>
          <button
            onClick={onClose}
            className='w-[48%] py-2 rounded-3xl bg-[#B0B0B080] hover:bg-[#B0B0B0] transition-all duration-300'
          >
            {t('SUBSCRIPTION_PLAN_CHANGE_BTN_CANCEL')}
          </button>
          <button
            onClick={onConfirm}
            disabled={loading}
            className='w-[48%] py-3 rounded-3xl text-white [background:linear-gradient(180deg,#6D49FF_0%,#A347FF_100%)] hover:bg-[#6D49FF] transition-all duration-300'
          >
            {t('SUBSCRIPTION_PLAN_CHANGE_BTN_PAY')}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};